import { Box, Button, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import Case from '../../interfaces/case';
import { AppDispatch } from '../../store/store';
import { useDispatch } from 'react-redux';
import { loadGridSelectedCase } from '../../store/slices/gridSelectedCaseSlice';
import { useNavigate, useLocation } from 'react-router-dom';

interface ActionsCellProps {
    currentCaseRow: Case;
}

const ActionsCell: React.FC<ActionsCellProps> = ({ currentCaseRow }) => {
    const dispatch: AppDispatch = useDispatch();

    const navigate = useNavigate();
    const location = useLocation();

    const handleRowClick = useCallback((row: Case) => {
        // save to redux as before
        dispatch(loadGridSelectedCase(row));

        // update query params without changing pathname (use replace to avoid extra history entries)
        const params = new URLSearchParams(location.search);
        params.set('client_name', row.client_name || '');
        params.set('client_reference_id', row.client_reference_id || '');
        const newSearch = `?${params.toString()}`;

        navigate(`${location.pathname}${newSearch}`, { replace: true });
        // SeeDetailsDrawer will open because gridSelectedCase in redux changed.
    }, []);

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                pr: 2,
                '&:hover button': {
                    visibility: 'visible',
                    opacity: 1,
                    transform: 'translateX(0)',
                },
            }}
        >
           
            <Button sx={{ userSelect: 'text' }} color="primary" size="small" onClick={() => handleRowClick(currentCaseRow)}>
                <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", fontSize: "12px", textTransform: 'none' }}>
                    {currentCaseRow.client_reference_id}
                </Typography>
            </Button>

        </Box>
    );
};



export default ActionsCell;
